import { render, staticRenderFns } from "./PlenaryCover.vue?vue&type=template&id=3c52376a&scoped=true&"
import script from "./PlenaryCover.vue?vue&type=script&lang=js&"
export * from "./PlenaryCover.vue?vue&type=script&lang=js&"
import style0 from "./PlenaryCover.vue?vue&type=style&index=0&id=3c52376a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c52376a",
  null
  
)

export default component.exports